import { isExternal, isInvest } from '@ally/transfer-account-utils';
function getTransferType(fromAccount, toAccount) {
    if (fromAccount === null || toAccount === null)
        return null;
    if (isInvest(fromAccount) || isInvest(toAccount))
        return 'INVEST';
    if (isExternal(fromAccount) || isExternal(toAccount))
        return 'EXTERNAL';
    return 'INTERNAL';
}
export default getTransferType;
//# sourceMappingURL=getTransferType.js.map